import React from "react";

const DrawerMenu = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36", isRegular = false}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill"
            fill={fill}
            d="M10.889 28.889v3.555h19.555V28.89H10.89ZM2 16.444V20h32v-3.556H2ZM5.556 4v3.556H25.11V4H5.556Z"
        />
    </svg>
);

export default DrawerMenu;
